import _com from "../../assets/js/common";

const state = {
	clientType: "",
	isGoodsList: false,
	isGoodsDetail: null,
	isYlxdsqCart: false,
	isShare:false,
	isShowOperat: false,
	ifBatchTitle: false,
	isShowConpon: false,
	isChangeConpon: false,
	clearScreen: false,
	messageClose: false,
	elderlyMode: false,
	selectStreamCode: "",
	isShowDetailInfo: false,
	hls: {
		url: "",
		isSelected: false,
	},
	batchObj: {},
};

const getters = {
	getClientType(state: any) {
		return state.clientType;
	},
	getIsGoodsList(state: any) {
		return state.isGoodsList;
	},
	getIsGoodsDetail(state: any) {
		return state.isGoodsDetail;
	},
	getIsYlxdsqCart(state: any) {
		return state.isYlxdsqCart;
	},
	getIsShare(state: any) {
		return state.isShare;
	},
	getIsShowOperat(state: any) {
		return state.isShowOperat;
	},
	getIfBatchTitle(state: any) {
		return state.ifBatchTitle;
	},
	getIsShowConpon(state: any) {
		return state.isShowConpon;
	},
	getIsChangeConpon(state: any) {
		return state.isChangeConpon;
	},
	getClearScreen(state: any) {
		return state.clearScreen;
	},
	getMessageClose(state: any) {
		return state.messageClose;
	},
	getElderlyMode(state: any) {
		return state.elderlyMode;
	},
	getSelectStreamCode(state: any) {
		return state.selectStreamCode;
	},
	getHls(state: any) {
		return state.hls;
	},
	getBatchObj(state: any) {
		return state.batchObj;
	},
	getIsShowDetailInfo(state: any) {
		return state.isShowDetailInfo;
	}
};

const actions = {
	getClientTypeAsync(context: any, source: string) {
		//获取购物车数据
		let type = "";
		if (source == "usq") {
			if (_com.browser().ylxdsq) {
				type = "client_type=app_ylxdsq";
			} else if (_com.browser().usqxcx) {
				type = "client_type=miniwx_ylxdsq";
			} else {
				type = "client_type=wap_ylxdsq";
			}
		}
		context.commit("setClientType", type);
	},
	getIsShowDetailInfoAsync(context: any, bool: boolean) {
		//是否显示商品详情弹窗
		context.commit("setIsShowDetailInfo", bool);
		},
	getIsShowOperatAsync(context: any, bool: boolean) {
		//是否显示操作弹框
		context.commit("setIsShowOperat", bool);
	},
	getIsGoodsListAsync(context: any, bool: boolean) {
		//获取购物车弹框
		context.commit("setIsGoodsList", bool);
	},
	getIsGoodsDetailAsync(context: any, bool: boolean) {
		//获取商品详情弹窗
		context.commit("setIsGoodsDetail", bool);
	},
	getYlxdsqCartAsync(context: any, bool: boolean) {
		//获取商品详情弹窗
		context.commit("setIsYlxdsqCart", bool);
	},
	getIsShareAsync(context: any, bool: boolean) {
		//获取商品详情弹窗
		context.commit("setIsShare", bool);
	},
	getIfBatchTitleAsync(context: any, bool: boolean) {
		//是否有优惠券
		context.commit("setIfBatchTitle", bool);
	},
	getIsShowConponAsync(context: any, bool: boolean) {
		//是否显示优惠券弹框
		context.commit("setIsShowConpon", bool);
	},
	getIsChangeConponAsync(context: any, bool: boolean) {
		//是否显示新增优惠券弹框
		context.commit("setIsChangeConpon", bool);
	},
	getClearScreenAsync(context: any, bool: boolean) {
		//是否清屏
		context.commit("setClearScreen", bool);
	},
	getMessageCloseAsync(context: any, bool: boolean) {
		//关闭/开启弹幕
		context.commit("setMessageClose", bool);
	},
	getElderlyModeAsync(context: any, bool: boolean) {
		//开启/关闭老人模式
		context.commit("setElderlyMode", bool);
	},
	getSelectStreamCodeAsync(context: any, code: string) {
		//当前手动选中流码
		context.commit("setSelectStreamCode", code);
		context.commit("setHls", {
			url: state.hls.url,
			isSelected: true,
		});
	},
	getHlsAsync(context: any, url: string) {
		//获取hls地址
		context.commit("setHls", {
			url: url,
			isSelected: false,
		});
	},
	setBatchObjAsync(context: any, obj: any) {
		context.commit("setBatchObj", obj);
	},
};

const mutations = {
	setIsShowDetailInfo(state: any, res: any) {
		state.isShowDetailInfo = res;
	},
	setClientType(state: any, res: any) {
		state.clientType = res;
	},
	setIsGoodsList(state: any, res: any) {
		state.isGoodsList = res;
	},
	setIsGoodsDetail(state: any, res: any) {
		state.isGoodsDetail = res;
	},
	setIsYlxdsqCart(state: any, res: any) {
		state.isYlxdsqCart = res;
	},
	setIsShare(state: any, res: any) {
		state.isShare = res;
	},
	setIsShowOperat(state: any, res: any) {
		state.isShowOperat = res;
	},
	setIfBatchTitle(state: any, res: any) {
		state.ifBatchTitle = res;
	},
	setClearScreen(state: any, res: any) {
		state.clearScreen = res;
	},
	setMessageClose(state: any, res: any) {
		state.messageClose = res;
	},
	setElderlyMode(state: any, res: any) {
		state.elderlyMode = res;
	},
	setSelectStreamCode(state: any, res: any) {
		state.selectStreamCode = res;
	},
	setIsShowConpon(state: any, res: any) {
		state.isShowConpon = res;
	},
	setIsChangeConpon(state: any, res: any) {
		state.isChangeConpon = res;
	},
	setHls(state: any, res: any) {
		if (state.selectStreamCode) {
			let url = res.url;
			let arr = url.split("?");
			arr[0] = arr[0].split("@")[0];
			url = arr[0] + "@" + state.selectStreamCode + "p?" + arr[1];
			res.url = url;
		}
		state.hls = res;
	},
	setBatchObj(state: any, res: any) {
		state.batchObj = res;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
